import { Type } from '@angular/core';

import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../PageBuilder/models/form-field.model';


export class TopMentionsMetadataFieldModel implements FormFieldModel {
    property: string;
    fieldComponent: Type<AbstractFormFieldComponent>;
    id?: string;

    constructor(
        property: string,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        id?: string
    ) {
        this.property = property;
        this.fieldComponent = fieldComponent;
        this.id = id;
    }
}
